import util from "@/option/common/util";

export default {
  methods: {
    getOptionTitle() {
      // 从主题中取标题配置
      const {
        titleSet: {
          titleFontSet = {},
          subTitleFontSet = {},
        },
        fontFamily,
      } = this.themeCfg
      let op = {
        show: this.validData(this.option.titleShow, false),
        text: this.option.title,
        subtext: this.option.subtext || '',
        textStyle: {
          color: this.option.titleColor || (titleFontSet?.color || '#333'),
          fontSize: this.option.titleFontSize || (titleFontSet?.size || 16),
          fontWeight: (titleFontSet?.isBold || 'bolder'),
          fontStyle: (titleFontSet?.isItalic || 'normal'),
          align: (titleFontSet?.align || undefined),
        },
        left: this.option.titlePosition || 'auto',
        subtextStyle: {
          color: this.option.subTitleColor || (subTitleFontSet?.color || '#aaa'),
          fontSize: this.option.subTitleFontSize || (subTitleFontSet?.size || 14),
          fontWeight: (subTitleFontSet?.isBold || 'normal'),
          fontStyle: (subTitleFontSet?.isItalic || 'normal'),
          align: (subTitleFontSet?.align || undefined),
        }
      }
      if (this.option.titleBindParam) {
        op.text = util.deepGet(this.datas, this.option.titleBindParam, '', this.$attrs, this.pageArgs);
      }
      return op
    },
    getOptionGrid() {
      // 从主题中取间距配置
      const {
        gapSet
      } = this.themeCfg
      return {
        height: this.option?.split ? Number(this.option?.split) * 10 : undefined,
        left: this.option.gridX || (gapSet?.paddingLeft || 20),
        top: this.option.gridY || (gapSet?.paddingTop || 60),
        right: this.option.gridX2 || (gapSet?.paddingRight || 20),
        bottom: this.option.gridY2 || (gapSet?.paddingBottom || 60)
      }
    },
    getOptionTip(prop = {}) {
      // 从主体中取tooltip的配置
      const {
        chartSet: {
          toolTipSet = {}
        }
      } = this.themeCfg
      return {
        ...{
          confine: this.option.tipConfine || false,
          show: this.validData(this.option.tipShow, true),
          formatter:
            this.formatter ?
              (params) => {
                return this.formatter(params, this.dataChart);
              } : undefined,
          backgroundColor: this.option.tipBackgroundColor || "rgba(0,0,0,0.5)",
          textStyle: {
            fontSize: this.option.tipFontSize || (toolTipSet?.size || 20),
            color: this.option.tipColor || (toolTipSet?.color || '#fff'),
          }
        },
        ...prop
      }
    },
    getOptionLegend(data) {
      // 图例配置
      const {
        chartSet: {
          legendSet = {}
        }
      } = this.themeCfg
      let t = this.option.legendTop, b = this.option.legendBottom, l = this.option.legendLeft,
        r = this.option.legendRight
      return {
        type: this.option.isCurrent ? 'scroll' : 'plain',
        show: this.validData(this.option.legend, true),
        orient: this.option.legendOrient || "horizontal",
        left: l || (this.option.legendPosition?.includes("l")
          ? "left"
          : this.option.legendPosition?.includes("r")
            ? "right"
            : "center"),
        top: t || (this.option.legendPosition?.includes("t")
          ? "6%"
          : this.option.legendPosition?.includes("b")
            ? "bottom"
            : this.option.legendPosition?.includes("c")
              ? "center"
              : "6%"),
        b: b,
        r: r,
        x: this.option.legendPosition || "right",
        icon: this.option.legendIcon,
        itemWidth: this.option.legendW || 25,
        itemHeight: this.option.legendH || 14,
        textStyle: {
          fontSize: this.option.legendFontSize || (legendSet?.size || 12),
          color: this.option.legendFontColor || (legendSet?.color || '#888888'),
        },
        data: (data || this.dataChart.series || this.dataChart).map((ele, index) => {
          return {
            name: ele.name,
            textStyle: this.getHasProp(!this.switchTheme, {
              fontSize: this.option.legendFontSize || (legendSet?.size || 12),
              color: this.option.legendFontColor || (legendSet?.color || this.getColor(index, true))
            })
          };
        })
          .sort((prev, next) => {
            if (this.option.legendOrder == "ascend") {
              return prev.name < next.name ? 1 : -1;
            } else {
              return next.name < prev.name ? 1 : -1;
            }
          }),
      };
    },

    getOptionLabel(prop = {}) {
      // 图例配置
      const {
        chartSet: {
          seriesLabelSet = {}
        }
      } = this.themeCfg
      return {
        ...{
          show: this.validData(this.option.labelShow, false),
          formatter:
            this.labelFormatter ?
              (params) => {
                return this.labelFormatter(params, this.dataChart);
              } : '{c}',
          fontSize: this.option.labelShowFontSize || (seriesLabelSet?.size || 14),
          color: this.option.labelShowColor || (seriesLabelSet?.color || 'inherit'),
          fontWeight: this.option.labelShowFontWeight || (seriesLabelSet?.isBold || 'normal'),
          ...prop
        }
      }
    },
    getXAxisOption(prop = {}) {
      const {
        chartSet: {
          axisTitleSet = {},
          axisLabelSet = {},
          splitLineBorderType = '',
          splitLineSet = {},
          xAxisSet = {},
        },
        fontFamily = '',
      } = this.themeCfg
      return {
        show: this.validData(this.option.xAxisShow, true),
        type: this.option.category ? "value" : "category",
        name: this.option.xAxisName,
        nameTextStyle: {
          fontFamily: this.option.xAxisNameFontFamily || (fontFamily || '微软雅黑'),
          color: this.option.xAxisColor || (axisTitleSet?.color || "#fff"),
          fontSize: this.option.xAxisFontSize || (axisTitleSet?.size || 14),
        },
        axisLine: {
          show: this.validData(this.option.xAxisLineShow, true),
          lineStyle: {
            color: this.option.xAxisLineColor || (xAxisSet?.color || "#fff"),
            width: this.option.xAxisLineWidth || (xAxisSet?.size || 1),
          },
        },
        axisTick: {
          show: this.option.xAxisTickHide ? false : true,
        },
        inverse: this.validData(this.option.xAxisInverse, false),
        splitLine: {
          show: this.validData(this.option.xAxisSplitLineShow, false),
          lineStyle: {
            type: this.option.xAxisSplitLineShowDotted ?
              [
                this.option.xAxisSplitLineOne || 5,
                this.option.xAxisSplitLineTwo || 8,
              ] : (splitLineBorderType || "solid"), //设置网格线类型 dotted：虚线   solid:实线
            color: this.option.xAxisSplitLineColor || (splitLineSet?.color || "#ccc"),
            width: this.option.xAxisSplitLineWidth || (splitLineSet?.size || 1),
          },
        },
        axisLabel: {
          show: this.validData(this.option.axisLabelShow, true),
          interval: this.option.xAxisInterval ? 0 : "auto",
          rotate: this.option.xAxisRotate || 0,
          textStyle: {
            color: this.option.xAxisColor || (axisLabelSet?.color || "#fff"),
            fontSize: this.option.xAxisFontSize || (axisLabelSet?.size || 14),
            fontFamily: this.option.xAxisFontFamily || (fontFamily || '微软雅黑')
          },
        },
        ...prop
      }
    },
    getRightYAxisOption(prop = {}) {
      const {
        chartSet: {
          axisTitleSet = {}, // 轴标题对应name
          axisLabelSet = {}, // 轴标签
          splitLineBorderType = '', // 网格线类型
          splitLineSet = {}, // 网格线
          yAxisSet = {}, // 轴线
        },
        fontFamily = '',
      } = this.themeCfg
      return {
        show: this.validData(this.option.showRightAxisName, true),
        type: this.option.category ? "category" : "value",
        name: this.option.rightAxisName,
        nameTextStyle: {
          color: this.option.rightAxisNameColor || (axisTitleSet?.color || "#fff"),
          fontSize: this.option.rightAxisNameFontSize || (axisTitleSet?.size || 14),
          fontFamily: this.option.rightAxisNameFontFamily || fontFamily,
          padding: [0, this.option.yAxisNameRight || 0, this.option.yAxisNameBottom || 0, 0]
        },
        axisLabel: {
          show: this.validData(this.option.rightAxisLabelShow, true),
          rotate: this.option.rightAxisRotate || 0,
          textStyle: {
            color: this.option.rightAxisColor || (axisLabelSet?.color || "#fff"),
            fontFamily: this.option.rightAxisFontFamily || fontFamily,
            fontSize: this.option.rightAxisFontSize || (axisLabelSet?.size || 14),
          },
        },
        axisLine: {
          show: this.validData(this.option.rightAxisLineShow, true),
          lineStyle: {
            color: this.option.rightAxisLineColor || (yAxisSet?.color || "#fff"),
            width: this.option.rightAxisLineWidth || (yAxisSet?.size || 1)
          },
        },
        inverse: this.validData(this.option.rightAxisInverse, false),
        splitLine: {
          show: this.validData(this.option.rightAxisSplitLineShow, false),
          lineStyle: {
            type: this.option.rightAxisSplitLineShowDotted ? [5, 8] : (splitLineBorderType || "solid"), //设置网格线类型 dotted：虚线   solid:实线
            color: this.option.rightAxisSplitLineColor || (splitLineSet?.color || "#ccc"),
            width: this.option.rightAxisMarkLineWidth || (splitLineSet?.size || 1),
          },
        },
        ...prop,
      }
    },
    getYAxisOption(prop = {}) {
      const {
        chartSet: {
          axisTitleSet = {}, // 轴标题对应name
          axisLabelSet = {}, // 轴标签
          splitLineBorderType = '', // 网格线类型
          splitLineSet = {}, // 网格线
          yAxisSet = {}, // 轴线
        },
        fontFamily = '',
      } = this.themeCfg
      return {
        show: this.validData(this.option.yAxisShow, true),
        type: this.option.category ? "category" : "value",
        name: this.option.yAxisName,
        nameTextStyle: {
          color: this.option.yAxisNameColor || (axisTitleSet?.color || "#fff"),
          fontSize: this.option.yAxisNameFontSize || (axisTitleSet?.size || 14),
          fontFamily: this.option.yAxisNameFontFamily || fontFamily,
          padding: [0, this.option.yAxisNameRight || 0, this.option.yAxisNameBottom || 0, 0]
        },
        axisLabel: {
          show: this.validData(this.option.yAxisShow, true),
          rotate: this.option.xAxisRotate || 0,
          textStyle: {
            color: this.option.yAxisColor || (axisLabelSet?.color || "#fff"),
            fontSize: this.option.yAxisFontSize || (axisLabelSet?.size || 14),
          },
        },
        axisLine: {
          show: this.validData(this.option.yAxisLineShow, true),
          lineStyle: {
            color: this.option.yAxisLineColor || (yAxisSet?.color || "#fff"),
            width: this.option.yAxisLineWidth || (yAxisSet?.size || 1)
          },
        },
        inverse: this.validData(this.option.yAxisInverse, false),
        splitLine: {
          show: this.validData(this.option.yAxisSplitLineShow, false),
          lineStyle: {
            type: this.option.yAxisSplitLineShowDotted ?
              [
                this.option.yAxisSplitLineOne || 5,
                this.option.yAxisSplitLineTwo || 8,
              ] : (splitLineBorderType || "solid"), //设置网格线类型 dotted：虚线   solid:实线
            color: this.option.yAxisSplitLineColor || (splitLineSet?.color || "#ccc"),
            width: this.option.yAxisSplitLineWidth || (splitLineSet?.size || 1),
          },
        },
        ...prop,
      }
    }
  }
}